import Forbidden from "pages/Forbidden";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../helpers/auth";

const PrivateRoute = ({ scopes, children }) => {
  const location = useLocation();
  const {
    user: { isAuthenticated, scopes: roleScopes },
  } = useAuth();

  if (isAuthenticated) {
    if (!scopes) {
      return children;
    }
    if (scopes && scopes.length > 0) {
      const allowed = roleScopes.filter((x) => scopes.includes(x));
      if (allowed && allowed.length > 0) return children;
    }
    return <Forbidden />;
  }
  return <Navigate to="/account/login" replace state={{ from: location }} />;
};
export default PrivateRoute;
